import { useSelector } from "react-redux";

import { TooltipDesc, TooltipName } from "components/base/Tooltip";
import { getAreaData } from "libs/stats";
import { getLocationInfo } from "redux/selectors/characterSelectors";

const TooltipSector = () => {
  const { area } = useSelector(getLocationInfo);

  const { name: areaName } = getAreaData(area);

  return (
    <>
      <TooltipName>Current Sector</TooltipName>
      <TooltipDesc>
        You are currently in {areaName}. You can travel to different sectors
        faster with your Sector Link.
      </TooltipDesc>
    </>
  );
};

export default TooltipSector;
